__turbopack_context__.v({
  "loading": "ConnectionShareModalList-module__Y9ZBDG__loading",
  "root": "ConnectionShareModalList-module__Y9ZBDG__root",
});
